module.exports = process.env.NODE_ENV === 'production' ? require('./build/mocks') : require('./build');

//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/airbnb-prop-types/index.js
// module id = 14
// module chunks = 0